import { DrawerContentScrollView } from "@react-navigation/drawer";
import firebase from "firebase";
import { observer } from "mobx-react";
import React from "react";
import { Dimensions, Image, SafeAreaView, StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { Icon } from "react-native-elements";
import { RFValue } from "react-native-responsive-fontsize";
import { navigate } from "../routes/Global";

const { width, height } = Dimensions.get("window");

const SideDrawer = observer((props) => {
  const items = [
    {
      icon: "home",
      text: "Home",
      type: "material-community",
      onPress: () => navigate("home"),
    },
    {
      icon: "file-account",
      text: "Verification",
      type: "material-community",
      onPress: () => navigate("verification"),
    },
    {
      icon: "account-cancel",
      text: "Suspended Users",
      type: "material-community",
      onPress: () => navigate("suspendedusers"),
    },
    {
      icon: "folder-search-outline",
      text: "Search Documents",
      type: "material-community",
      onPress: () => navigate("searchdocuments"),
    },
    {
      icon: "account-box",
      text: "Add Moderators",
      type: "material-community",
      onPress: () => navigate("addmoderators"),
    },
    {
      icon: "logout",
      text: "Logout",
      type: "material-community",
      onPress: async () => await firebase.auth().signOut(),
    },
  ].filter((r) => r);

  return (
    <>
      <View style={styles.headerImageView}>
        <Image source={require("../assets/header.png")} style={styles.image} resizeMode="contain" />
      </View>
      <DrawerContentScrollView {...props} style={{ flex: 1 }} bounces={false} contentContainerStyle={styles.contentContainerStyle} showsVerticalScrollIndicator={false} showsHorizontalScrollIndicator={false}>
        <SafeAreaView style={{ flex: 1 }}>
          {items.map((i, ind) => (
            <TouchableOpacity activeOpacity={1} onPress={i.onPress} style={[styles.rowView, styles.parentRowView]} key={i + ind.toString()}>
              <View style={[styles.rowView, { flex: 1, justifyContent: "space-between" }]}>
                <Icon name={i.icon} size={25} type={i.type} color="#edd08b" containerStyle={styles.iconContainerStyle} iconStyle={[styles.icon, i.iconStyle ? i.iconStyle : null]} />
                <Text style={[styles.labelStyle]}>{i.text}</Text>
              </View>
              <Icon name={"chevron-right"} size={25} type={"material"} color="#d3d3d3" iconStyle={styles.icon} />
            </TouchableOpacity>
          ))}
        </SafeAreaView>
      </DrawerContentScrollView>
    </>
  );
});

export default SideDrawer;

const styles = StyleSheet.create({
  locationRowView: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginHorizontal: 5,
    marginTop: 5,
  },
  locationText: { fontFamily: "avenir", fontSize: RFValue(15), marginLeft: 5 },
  banner: {
    backgroundColor: "red",
    position: "absolute",
    bottom: 0,
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5,
    flex: 1,
    paddingHorizontal: width * 0.05,
    paddingVertical: 5,
  },
  text: {
    color: "white",
    fontFamily: "avenir",
    fontSize: RFValue(13),
    textAlign: "center",
  },
  iconContainerStyle: { flex: 0.35, alignItems: "flex-start" },
  icon: { marginHorizontal: 10 },
  contentContainerStyle: { paddingBottom: height * 0.2 },
  labelStyle: {
    fontFamily: "avenir",
    color: "black",
    flex: 1,
  },
  parentRowView: { justifyContent: "space-between", marginVertical: 0 },
  rowView: {
    flexDirection: "row",
    alignItems: "center",
    marginVertical: height * 0.025,
  },
  image: {
    width: width * 0.2,
    height: height * 0.2,
  },
  headerImageView: {
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#181d21",
    // marginBottom: -height * 0.05,
  },
  container: {
    flex: 1,
    backgroundColor: "white",
  },
});
